export default class ModifyPwdParam {
  constructor (loginName, oldPassword, password, pwdConfirm,vCode,appCode,identity,appServiceCode) {
    this.loginName = loginName
    this.oldPassword = oldPassword
    this.password = password
    this.pwdConfirm = pwdConfirm
    this.vCode=vCode
    this.appCode=appCode
    this.identity=identity
    this.appServiceCode=appServiceCode
  }
}
